// Namespaces
wfx = wfx || {};
wfx.ui = wfx.ui || {};
/**
 * @param $cont The container element of the signature component.
 * @constructor
 */
wfx.ui.SignaturePad = function ($cont) {

    let priv = {},
        that = {};

    priv.$cont = $cont;
    priv.canvas = $('.js-signature_pad', priv.$cont);
    priv.signaturePad = null;

    /**
     *
     */
    priv.init = function () {
        if (!priv.canvas || !priv.canvas.length) {
            return;
        }

        priv.canvas
            .attr('width', priv.canvas.parent().outerWidth() > 650 ? 650 : priv.canvas.parent().outerWidth())
            .attr('height', 200);

        let $clearAction = $('.js-signature_pad_clear', priv.$cont);

        priv.signaturePad = new SignaturePad(priv.canvas[0], {
            minWidth: 1.5,
            maxWidth: 2.5,
            penColor: '#501E96',
            onBegin: function () {
                priv.clearActionToggle($clearAction);
            },
            onEnd: function () {
                priv.clearActionToggle($clearAction);
            }
        });

        $(window).on('resize', function () {
            //priv.resize();
        });


        $clearAction.click(function () {
            priv.signaturePad.clear();
            priv.clearActionToggle($clearAction);
        });

        priv.clearActionToggle($clearAction);
    }

    /**
     * @param $clearAction
     */
    priv.clearActionToggle = function ($clearAction) {
        if (priv.signaturePad.isEmpty()) {
            $clearAction.addClass('disabled');
        } else {
            $clearAction.removeClass('disabled');
        }
    };

    /**
     *
     */
    priv.resize = function () {
        let ratio = Math.max(window.devicePixelRatio || 1, 1);
        priv.canvas.width = priv.canvas.offsetWidth * ratio;
        priv.canvas.height = priv.canvas.offsetHeight * ratio;
        priv.canvas.getContext('2d').scale(ratio, ratio);
        priv.signaturePad.clear(); // otherwise isEmpty() might return incorrect value

        // Alternative:
        // $("#canvas").outerHeight($(window).height()-$("#canvas").offset().top- Math.abs($("#canvas").outerHeight(true) - $("#canvas").outerHeight()));
    };

    that.getPng = function () {
        if (priv.signaturePad.isEmpty()) {
            return null;
        }

        return priv.signaturePad.toDataURL('image/png');
    };

    priv.init();

    return that;
};
